<div class="bell-container" (click)="toggleNotifications($event)">
  <img src="./assets/notificacion.svg" alt="" />
  @if(notifications.length > 0){
  <span class="notification-count">{{ notifications.length }}</span>
  }
</div>

@if(showNotifications){
<div class="notification-list">
  <div class="button-container">
    <a class="button-notificacion" (click)="clearNotifications()">
      Marcar como leídos
    </a>
  </div>
  <div class="notification-list-cont">
    <ul>
      @for( notification of notifications; track notification){
      <li>{{ notification }}</li>
      } @if(notifications.length === 0){
      <li>No hay notificaciones</li>
      v }
    </ul>
  </div>
</div>
}
